export default __webpack_public_path__ + "static/media/logo-camera.7c0fe7ba.png";